import Rotas from "@/rotas";
import { persistor, store } from "@/store";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Suspense } from "react";
import { Blocks } from 'react-loader-spinner';
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { PersistGate } from "redux-persist/integration/react";


const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
        },
    }
})


function SuspenseLoader() {
    return (
        <div className="flex justify-center items-center h-screen w-screen flex-col bg-gray-100 overflow-hidden fixed top-0 left-0">
            <Blocks
                visible={true}
                width="200"
                height="200"
                color="#3f51b5" // Replace with your primary color
            />
            <p className="text-lg text-center">Carregando...</p>
        </div>
    )
}


export default function App() {

    return (
        <BrowserRouter>
            <Suspense fallback={<SuspenseLoader />}>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <QueryClientProvider client={queryClient}>
                            <Rotas />
                            <ToastContainer
                                position="top-right"
                                autoClose={3000}
                                hideProgressBar={false}
                                newestOnTop={true}
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                                theme={'colored'}
                            />
                        </QueryClientProvider>
                    </PersistGate>
                </Provider>
            </Suspense>
        </BrowserRouter>
    )
}

